module.exports = __webpack_public_path__ + "static/media/illustration-element-02.3d5bb4f6.svg";